import classNames from 'classnames';
import { type ReactElement } from 'react';

import { type OrderedStepProps } from './OrderedStep';
import { OrderedStepsContext } from './useOrderedStepContext';

import './OrderedSteps.css';

export type OrderedStepsProps = {
  /**
   * The OrderedStep(s) contained within the OrderedSteps
   */
  children: ReactElement<OrderedStepProps> | ReactElement<OrderedStepProps>[];
  /**
   * className for the element
   */
  className?: string;
  /**
   * Specifies the width of the element
   * @default content
   */
  fit?: 'content' | 'parent';
};

export const OrderedSteps = ({
  children,
  className,
  fit = 'content',
  ...rest
}: OrderedStepsProps) => (
  <ul
    className={classNames(
      'OrderedSteps__list',
      className,
      fit === 'content' && 'OrderedSteps__contentFit',
    )}
    {...rest}
  >
    <OrderedStepsContext.Provider value={{ fit }}>
      {children}
    </OrderedStepsContext.Provider>
  </ul>
);
